import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { matchRoutes } from 'react-router-config'
import classNames from 'classnames'
import { Layout, Row, Col } from 'antd'
import Cookies from 'js-cookie'

import routes from '_src/routes'
import { useAppDispatch, useAppSelector } from '_src/store/hooks'

import InftHeader from '_src/components/InftHeader'
import Advertise from '_src/components/Advertise'
import InftFooter from '_src/components/InftFooter'
import Convert from '_src/pages/global/convert'

import { flattenArray, findArrayParents } from '_src/utils'
import { initWeb3, transformNetworkId, transformChainId } from '_src/utils/w3'

import { setActiveUrl } from '_src/store/menu/reducer'
import { loginAsync } from '_src/store/global/actions'

import { setWeb3, setProvider, clearWalletStore } from '_src/store/wallet/reducer'
import { setConnected, setAddress, clearGlobalStore } from '_src/store/global/reducer'

import { setNetworkIdAction, setChainIdAction } from '_src/store/global/actions'

import { GlobalWallet } from '_src/hooks/useWallet'

// import { CreateWeb3Modal } from "_src/wallet/wallet"; // 配置项
import { web3Modal } from '_src/wallet/wallet' // 配置项

import './index.less'

const { Header, Content } = Layout

const lclose = sessionStorage.getItem('close') || false

const routeArray = flattenArray(routes())

export default function PageLayout({ children, className }) {
  // const { chainId } = useAppSelector((store) => store.global);
  const { web3 } = useAppSelector((store) => store.wallet)
  // const web3Modal = CreateWeb3Modal(chainId);

  const history = useHistory()
  const dispatch = useAppDispatch()
  const { pathname } = useLocation()

  const [show, setShow] = useState(false)
  const [close, setClose] = useState(lclose)
  const [run, setRun] = useState(false)

  // 广告位
  const handlClose = () => {
    setClose(true)
    setRun(true)
    sessionStorage.setItem('close', true)
  }
  // 导航操作 start
  const handleSetActiveUrl = (pathname) => {
    // 设置导航焦点
    const marchRoutes = matchRoutes(routeArray, pathname)
    const path = marchRoutes[0]?.match?.path || ''

    if (path) {
      const urls = findArrayParents(routes(), (data) => data.path === path)
      urls && dispatch(setActiveUrl(urls))
    }
  }
  const historyParameter = (pathname) => {
    const historyItem = routeArray.find((item) => item.path.split(/[/#]/)[1] === pathname.split(/[/#]/)[1])
    if (historyItem) {
      const { hideFooter } = historyItem
      setShow(hideFooter)
    }
  }
  useEffect(() => {
    historyParameter(location.pathname)
    history.listen((historyLocation) => {
      // 每次路由变化都会执行这个方法
      historyParameter(historyLocation.pathname)
      handleSetActiveUrl(historyLocation.pathname)
      window && window.scrollTo(0, 0)
    })
  }, [history])
  // 导航操作 end

  // // 钱包 start
  // 钱包断开连接
  const resetApp = async () => {
    if (web3 && web3.currentProvider && web3.currentProvider.close) {
      await web3.currentProvider.close()
    }
    await web3Modal.clearCachedProvider()
    // 清空为默认值的操作
    dispatch(clearGlobalStore())
    dispatch(clearWalletStore())
  }

  // 钱包监听
  const subscribeProvider = async (provider) => {
    if (!provider.on) {
      return
    }

    provider.on('close', () => resetApp())
    provider.on('accountsChanged', async (accounts) => {
      //TODO 账户全都断开 为啥不调用  provider.on("close") ???
      if (accounts.length > 0) {
        const [address] = accounts
        dispatch(setAddress(address))
        dispatch(loginAsync())
      } else {
        resetApp()
      }

      Cookies.remove('access_token')
    })
    provider.on('chainChanged', async (chainId) => {
      // chainid   MetaMask回的是 16进制，walletconnect 返回的的是 10 进制
      const tChainId = transformChainId(chainId)
      if (tChainId) {
        dispatch(setChainIdAction(tChainId)) // store 中存储 chainId localStorage 自动同步
      }
      const tNetworkId = transformNetworkId(chainId)
      if (tNetworkId) {
        dispatch(setNetworkIdAction(tNetworkId)) // store 中存储 networkId localStorage 自动同步
        dispatch(loginAsync())
      }
    })

    // walletconnect  EIP-1193 不支持 networkChanged 监听事件
    // provider.on("networkChanged", async (networkId) => {
    //   dispatch(setNetworkIdAction(networkId)); // store 中存储 networkId localStorage 自动同步
    //   dispatch(loginAsync());
    // });
  }

  // 钱包连接
  const onConnect = async () => {
    try {
      const provider = await web3Modal.connect().catch((error) => {
        console.log('error', error)
        // 清空为默认值的操作
        dispatch(clearGlobalStore())
        dispatch(clearWalletStore())
        return new Promise((resolve) => {
          resolve({ connected: false })
        })
      })

      await subscribeProvider(provider)

      await provider.enable()
      const web3 = initWeb3(provider)
      dispatch(setWeb3(web3)) // store 中存储 web3 localStorage 不自动同步

      const accounts = await web3.eth.getAccounts()

      const [address] = accounts
      dispatch(setAddress(address)) // store 中存储 address localStorage 自动同步

      const networkId = await web3.eth.net.getId()
      dispatch(setNetworkIdAction(networkId)) // store 中存储 networkId localStorage 自动同步

      const chainId = await web3.eth.chainId()
      dispatch(setChainIdAction(chainId)) // store 中存储 chainId localStorage 自动同步

      dispatch(setProvider(provider)) // store 中存储 provider localStorage 不自动同步

      await dispatch(loginAsync())
      dispatch(setConnected(true)) // store 中存储 connected localStorage 自动同步

      return new Promise((resolve) => {
        resolve({ connected: true })
      })
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject({ connected: false })
      })
    }
  }

  const walletFunc = {
    walletConnect: onConnect, // 连接钱包
    walletDisconnect: resetApp, // 断开连接
  }
  // 钱包 end

  useEffect(() => {
    //  设置导航焦点
    handleSetActiveUrl(pathname)
    // 钱包
    if (web3Modal?.cachedProvider) {
      onConnect()
    }
  }, [])

  return (
    <GlobalWallet.Provider value={walletFunc}>
      <Layout className={classNames('inft-page-layout', className)}>
        <Header className="cust-header">
          <Row>
            <Col span={24}>
              <InftHeader />
            </Col>
            {!close && (
              <Col span={24}>
                <Advertise handlClose={handlClose} />
              </Col>
            )}
          </Row>
        </Header>
        <Content className={classNames('cust-content', { pt80: close, 'pt80-animation': run })}>{children}</Content>
        {!show && <InftFooter />}
        {/* 兑换弹窗 */}
        <Convert />
      </Layout>
    </GlobalWallet.Provider>
  )
}
